import { css } from 'styled-components';
import { getThemeColor } from 'src/themes/themeUtils';
import {
  gridUnit,
  sideGutter,
} from 'src/design/styleguide/common/measurements';

export const gridGap = `${gridUnit * 6}px;`;

export const pageShellStyles = `
  padding: 0 ${gridUnit * 4}px ${gridUnit * 10}px;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: ${gridUnit * 10}px ${sideGutter} ${gridUnit * 15}px ${sideGutter};
  }
`;

export const layoutStyles = `
  display: grid;
  grid-gap: ${gridUnit * 4}px;

  @media (min-width: 768px) {
    grid-gap: ${gridGap}
  }
`;

export const specialGradient = css`linear-gradient(to bottom, ${getThemeColor('primary')}, #ff9d82);`;

export const topBottomPanelPadding = `${gridUnit * 8}px`;
export const sidePanelPadding = `${gridUnit * 4}px`;
export const sidePanelPaddingBreakpointSmall = `${gridUnit * 6}px`;
